import React from 'react'
import { LinearProgress, CircularProgress, useTheme } from '@mui/material'
import { progressComponentTypes } from '../variables'

export const StyledLoadingIndicator = (props) => {
  const { loaderType = progressComponentTypes.CIRCULAR_PROGRESS, sx, style, color, area, size } = props
  const theme = useTheme()

  const defaultSX = {
    backgroundColor: theme.palette.brand.primary.forest,
    borderRadius: '6px',
    '.MuiLinearProgress-bar1Indeterminate': {
      backgroundColor: theme.palette.brand.primary.growth,
      borderRadius: '6px'
    },
    '.MuiLinearProgress-bar2Indeterminate': {
      backgroundColor: theme.palette.brand.primary.growth,
      borderRadius: '6px'
    }
  }

  const defaultStyles = {
    circularProgressStyle: { color: 'white' },
    linearProgressStyle: { height: 2, backgroundColor: theme.palette.brand.primary.forest }
  }

  switch (loaderType) {
    case progressComponentTypes.LINEAR_PROGRESS: {
      return (<LinearProgress area={area} color={color || 'primary'} style={style || defaultStyles.linearProgressStyle} sx={sx || defaultSX} />)
    }
    case progressComponentTypes.CIRCULAR_PROGRESS: {
      return (<CircularProgress area={area} size={size || 15} sx={style || defaultStyles.circularProgressStyle} />)
    }
    default: return false
  }
}
